<template>
  <div
    class="center-box d-flex-center w-100 h-100"
    :class="{
      'flex-column': directionColumn,
    }"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'CenterBox',

    props: {
      directionColumn: Boolean, // set true when you contain fit-height element
    },
  };
</script>
